import React from 'react';
import styled from '@emotion/styled';

export const EpickStylistHeader: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Wrap>
      <Title>스타일링</Title>
    </Wrap>
  );
};

const Wrap = styled.div`
  padding: 20px 0 16px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 58px;
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
`;
